<template>
  <div>
    <v-slide-group v-model="pricing" center-active show-arrows style="display: flex; align-items: center; flex-direction: column;">
      <v-hover v-for="plan in plans" v-slot:default="{ hover }" :key="plan.name">
        <v-slide-item
          :class="hover ? 'elevation-5' : 'elevation-0'"
          class="align-self-center" :disabled="$store.state.loggedIn"
          v-slot:default="{ active, toggle }"
        >
          <v-card
            style="border: 3px solid #55ECC6; transition: all 0.14s ease-in-out;"
            class="ma-4 text-center"
            :width="$vuetify.breakpoint.xlOnly ? 500 : 400"
            @click="$store.state.loggedIn ? undefined : toggle()"
            :class="active ? 'py-7' : 'py-2'"
          >
            <p class="mt-4 headline primary--text font-weight-medium">{{ plan.name }}</p>
            <div class="font-weight-light">
              <template v-if="plan.name === 'Non-Profit'">
                <p class="body-1 mb-1">
                  <span class="display-1">$25</span>/mo
                </p>
                <p class="font-weight-light caption">Base Payment — Must Be 501(c)(3)</p>
                <p class="mb-2">
                  +
                  <span class="font-weight-regular">$19/mo</span> per provider
                </p>
                <p class="mb-2">
                  +
                  <span class="font-weight-regular">$10/mo</span> per mid-level staff
                </p>
              </template>

              <template v-else-if="plan.name === 'Private Practice'">
                <p class="body-1 mb-0">
                  <span class="display-1">$39</span>/mo
                </p>
                <p class="font-weight-light caption">Base Payment</p>
                <p class="mb-2">
                  +
                  <span class="font-weight-regular">$29/mo</span> per provider
                </p>
                <p class="mb-2">
                  +
                  <span class="font-weight-regular">$15/mo</span> per mid-level staff
                </p>
              </template>

              <template v-else-if="plan.name === 'Billing Agency'">
                <p class="body-1 mb-0">
                  <span class="display-1">$45</span>/mo
                </p>
                <p class="font-weight-light caption">Base Payment</p>
                <p class="mb-2">
                  +
                  <span class="font-weight-regular">$35/mo</span> per client*
                </p>
                <p class="mb-3 caption font-weight-light">
                  *
                  <!-- is a practice that you handle billing for. -->
                  <span class="font-weight-regular">A client</span> is a company that you handle billing for.
                </p>
              </template>
            </div>
            <v-fade-transition>
              <v-overlay
                v-show="active"
                absolute
                :style="$store.state.loggedIn ? '' : 'border-radius: 12px !important;'"
                color="primary"
              >
                <v-scale-transition>
                  <v-icon v-if="active && !$store.state.loggedIn" color="primary lighten-4" size="48" v-text="'mdi-close'"></v-icon>
                </v-scale-transition>
              </v-overlay>
            </v-fade-transition>
          </v-card>
        </v-slide-item>
      </v-hover>
    </v-slide-group>

    <v-expand-transition v-if="!$store.state.loggedIn">
      <v-sheet v-show="pricing != null" color="grey lighten-5" tile>
        <v-col class="fill-height" align="center" justify="center">
          <h3 class="title my-6">
            Ready to get started as a
            {{ planName(pricing) }}?
          </h3>
          <base-btn
            color="primary"
            min-height="64"
            min-width="169"
            x-large
            :href="`/signup?plan=${pricing}`"
            class="mb-10 elevation-0"
            outlined
            style="border-width: 2.5px;"
          >
            <span class="font-weight-bold">Signup Now</span>
            <!-- todo: open dialog saying billit only available on dekstop -->
          </base-btn>
        </v-col>
      </v-sheet>
    </v-expand-transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pricing: 1,
    }
  },
  computed: {
    plans() {
      if (this.$store.state.loggedIn) {
        return [
          {
            name: "Non-Profit"
          },
          {
            name: "Private Practice"
          },
          {
            name: "Billing Agency"
          }
        ]
      } else if (this.$store.state.visitorType === 'practice') {
        return [
          {
            name: "Non-Profit"
          },
          {
            name: "Private Practice"
          }
        ]
      } else if (this.$store.state.visitorType === 'agency') {
        return [
          {
            name: "Billing Agency"
          }
        ]
      } else if (this.$store.state.visitorType === 'browsing') {
        return [
          {
            name: "Non-Profit"
          },
          {
            name: "Private Practice"
          },
          {
            name: "Billing Agency"
          }
        ]
      }
    }
  },
  methods: {
    planName(i) {
      switch (i) {
        case 0:
          return "Non-Profit"
        case 1:
          return "Private Practice"
        case 2:
          return "Billing Agency"
      }
    }
  },
  mounted() {
    if (this.$store.state.loggedIn) {
      this.pricing = this.$store.state.practiceData.plan
    }
    else {
      setTimeout(() => {
        this.pricing = null
      }, 300)
    }
  }
}
</script>

<style>
.v-card--link:focus:before {
    opacity: 0 !important;
}
</style>